var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEllipsisH = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_ellipsis-h",
    "data-name": "Icon - ellipsis-h",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.87,
    height: 3.552,
    viewBox: "0 0 16.87 3.552",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ellipsis-h",
    d: "M18.211,225.776A1.776,1.776,0,1,1,16.435,224,1.774,1.774,0,0,1,18.211,225.776ZM23.094,224a1.776,1.776,0,1,0,1.776,1.776A1.774,1.774,0,0,0,23.094,224ZM9.776,224a1.776,1.776,0,1,0,1.776,1.776A1.774,1.774,0,0,0,9.776,224Z",
    transform: "translate(-8 -224)",
    fill: "#737373"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEllipsisH);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - ellipsis-h.eb35633f82dcb1037fae374143a372dc.svg";